import { useState } from "react";

// Before/after reveal slider: left portion shows the seller's ORIGINAL, right shows the AI version.
export default function CompareSlider({ before, after }) {
  const [pos, setPos] = useState(50);
  return (
    <div className="relative aspect-square w-full select-none overflow-hidden rounded-xl border border-slate-200 bg-slate-50" data-testid="compare-slider">
      <img src={after} alt="AI version" className="absolute inset-0 h-full w-full object-contain" draggable={false} />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt="original" className="h-full w-full object-contain" draggable={false} />
      </div>
      <div className="pointer-events-none absolute bottom-0 top-0 w-0.5 bg-white shadow" style={{ left: `${pos}%` }} />
      <span className="absolute left-2 top-2 rounded bg-black/50 px-1.5 py-0.5 text-[10px] font-semibold text-white">Original</span>
      <span className="absolute right-2 top-2 rounded bg-black/50 px-1.5 py-0.5 text-[10px] font-semibold text-white">AI version</span>
      <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(+e.target.value)} data-testid="compare-range"
        className="absolute bottom-3 left-1/2 w-4/5 -translate-x-1/2 cursor-ew-resize accent-white" aria-label="Compare original and AI version" />
    </div>
  );
}
